/**
 * components/ErrorState.tsx
 * Displays when an error occurs loading projects.
 */

import React from 'react';
import { Box, Typography, Button, Alert, Stack } from '@mui/material';
import { colors } from '../../../ui/colors';

interface ErrorStateProps {
  title: string;
  message: string;
  onRetry?: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title,
  message,
  onRetry,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3,
        minHeight: 300,
      }}
    >
      <Stack spacing={2} sx={{ maxWidth: 500 }}>
        <Alert severity="error">
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
          <Typography variant="body2" sx={{ marginTop: 1 }}>
            {message}
          </Typography>
        </Alert>

        {onRetry && (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="contained"
              onClick={onRetry}
              sx={{
                backgroundColor: colors.accent || '#ff9500',
                color: '#ffffff',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: colors.accentHover || '#e68900',
                },
              }}
            >
              Try Again
            </Button>
          </Box>
        )}
      </Stack>
    </Box>
  );
};
